// contexts/ActiveCategoryContext.js
import { createContext, useContext, useState } from 'react';

const ActiveCategoryContext = createContext();

export function ActiveCategoryProvider({ children }) {
  const [activeMenu, setActiveMenu] = useState({
    category: '',
    subcategory: '',
    subsubcategory: '',
  });

  return (
    <ActiveCategoryContext.Provider value={{ activeMenu, setActiveMenu }}>
      {children}
    </ActiveCategoryContext.Provider>
  );
}

export function useActiveCategoryContext() {
  return useContext(ActiveCategoryContext);
}
